export const ONEROSTER_BASE_NAV_ROUTE = 'oneroster'
export const ONEROSTER_ROSTERING_NAV_ROUTE = `${ONEROSTER_BASE_NAV_ROUTE}_rostering`
export const COMMON_CARTRIDGE_BASE_NAV_ROUTE = 'common_cartridge'
